import React from 'react'
import { ModelContext } from '@morningtrain/react-resources'
import { observable } from 'mobx'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function EnvToModel ({ path, children }) {
  const modelRef = React.useRef(observable.map())
  const model = modelRef.current

  const [value] = useEnvValue(path)

  React.useEffect(() => {
    model.replace(value || {})
  }, [value])

  return (
    <ModelContext.Provider value={model}>
      {children}
    </ModelContext.Provider>
  )
}
